import type ExcelJS from "exceljs";
import brasaoMinasGerais from "assets/brasao_minas_gerais.png";

const GOVERNMENT_LINES = [
  "GOVERNO DO ESTADO DE MINAS GERAIS",
  "Secretaria de Estado de Desenvolvimento Social - SEDESE",
  "Subsecretaria de Assistencia Social - SUBAS",
];

export const GOVERNMENT_REPORT_HEADER_TEXT = GOVERNMENT_LINES.join("\n");

export const prependGovernmentReportHeader = (worksheet: ExcelJS.Worksheet, lastColumn: number): number => {
  worksheet.spliceRows(1, 0, [], [], [], []);

  GOVERNMENT_LINES.forEach((line, index) => {
    const rowNumber = index + 1;
    worksheet.mergeCells(rowNumber, 1, rowNumber, lastColumn);

    const cell = worksheet.getCell(rowNumber, 1);
    cell.value = line;
    cell.font = {
      name: "Arial",
      size: index === 0 ? 14 : 12,
      bold: index === 0,
      color: { argb: "FF000000" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "left",
      indent: 7,
    };
    worksheet.getRow(rowNumber).height = index === 0 ? 24 : 20;
  });

  worksheet.getRow(4).height = 10;

  return 4;
};

export const addGovernmentReportLogo = async (
  workbook: ExcelJS.Workbook,
  worksheet: ExcelJS.Worksheet,
  row = 0,
): Promise<void> => {
  try {
    const response = await fetch(brasaoMinasGerais);

    if (!response.ok) {
      return;
    }

    const bytes = new Uint8Array(await response.arrayBuffer());
    let binary = "";

    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });

    const imageId = workbook.addImage({
      base64: btoa(binary),
      extension: "png",
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row },
      ext: { width: 58, height: 58 },
    });
  } catch {
    // The textual header remains available when the image cannot be loaded.
  }
};
